import { Component } from 'react'
import { Overline } from '../../../Nodes/Typography'
import Icon from '../../../Nodes/Icon'

/** NOTE: if you're using this component in conjunction with the <Tabs> component, 
 *  be mindful that the 'active' and 'onClick' properties are being added in <Tabs> - rrogers 2019-03-01 */
class Tab extends Component {
    state = {
        isHovered: false
    }
    static defaultProps = { 
        color: '#000',
        fontColor: '#fff'
    }

    render() {
        const { title, color, fontColor, active, onClick, icon } = this.props

        const style = { borderColor: color }
        if (this.state.isHovered) {
            style.color = fontColor
            style.background = color
        }

        return (
            <div className={'tabs__header__tab' + (active ? ' tabs__header__tab--active' : '')}
                style={style}
                onClick={onClick}
                onMouseOver={() => this.setState({ isHovered: true })}
                onMouseLeave={() => this.setState({ isHovered: false })}>
                <Overline dangerouslySetInnerHTML={{ __html: title }} />
                { icon && <Icon>{icon}</Icon> }
            </div>
        )
    }
}

export default Tab